import Box from '@mui/material/Box';

import { IBasicUserFragment } from 'graphql/types';
import {
    ListItem,
    ListItemAvatar,
    ListItemText,
} from 'common/components/ListItem';
import { ChipGroup } from 'common/components/Chip';
import { UserAvatar } from 'user/components/UserAvatar';
import { UserExtraFieldsChips } from 'user/components/UserExtraFieldsChips';

interface IProps {
    user?: IBasicUserFragment | null;
    userName?: string | null;
}

export const UserDrawerHeader = ({ user, userName }: IProps) => {
    if (!user && !userName) return null;

    return (
        <Box sx={{ py: 2 }}>
            <ListItem p={{ xs: 2, sm: 4 }} py={0}>
                <ListItemAvatar>
                    <UserAvatar
                        bgColor="primary"
                        size={50}
                        sizeSm={64}
                        user={
                            user ?? (userName ? { name: userName } : undefined)
                        }
                    />
                </ListItemAvatar>
                <ListItemText primary={user?.name ?? userName}>
                    {user && (
                        <ChipGroup>
                            <UserExtraFieldsChips user={user} />
                        </ChipGroup>
                    )}
                </ListItemText>
            </ListItem>
        </Box>
    );
};
